import { render, staticRenderFns } from "./purchase-record.vue?vue&type=template&id=c15c1ff8"
import script from "./purchase-record.vue?vue&type=script&lang=ts"
export * from "./purchase-record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports